"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisibleNights = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

/**
 * @typedef NightsOptions
 * @property {number[]} nights from [2, 3, 4] to [5, 6, 7, 8, 9]
 * @property {number} count 3, 4, 5
 * @property {number} selectedNights 3, 4, 5
 * @param {NightsOptions}
 * @returns {number[]} [5, 6, 7, 8, 9] => [6, 7, 8]
 */
var getVisibleNights = function getVisibleNights(_ref) {
  var nights = _ref.nights,
      count = _ref.count,
      selectedNights = _ref.selectedNights;
  var length = nights.length;

  if (length <= count) {
    return nights;
  }

  var nextNights = (0, _toConsumableArray2["default"])(nights);
  var removeMax = false;

  while (nextNights.length > count) {
    if (removeMax && nextNights[nextNights.length - 1] !== selectedNights) {
      nextNights.pop();
    } else if (nextNights[0] !== selectedNights) {
      nextNights.shift();
    }

    removeMax = !removeMax;
  }

  return nextNights;
};

exports.getVisibleNights = getVisibleNights;